import { BaseModel } from './base.model';
import { JsonObject } from '../helpers';
import { ORG_DEFAULT_AGENT_ID } from '../services/shortcut.service';
import { PropModel } from './prop.model';

type AgentBadge = {
  title: string;
  image: string;
};

class AgentPortalConfig extends PropModel {
  description: string;
  greeting: string;
  badge: AgentBadge;

  constructor(props: JsonObject = {}) {
    super();
    const data = props as Record<keyof AgentPortalConfig, unknown>;
    this.description = (data.description as string) || '';
    this.greeting = (data.greeting as string) || '';
    this.badge = (data.badge as AgentBadge) || {
      title: '',
      image: '',
    };
  }
}

export class AgentModel extends BaseModel {
  orgId: string;
  name: string;
  description: string;
  portal: AgentPortalConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof AgentModel, unknown>;

    this.orgId = (data.orgId as string) || '';
    this.name = (data.name as string) || '';
    this.description = (data.description as string) || '';
    this.portal = new AgentPortalConfig((data.portal as JsonObject) || {});
  }

  get isDefaultAgent(): boolean {
    return this.id === ORG_DEFAULT_AGENT_ID;
  }

  get badgeTitle(): string {
    if (!this.portal?.badge?.title) {
      return this.isDefaultAgent ? 'Default Assistant' : 'Assistant';
    }
    return this.portal.badge.title;
  }

  get label(): string {
    const addSuffix = !String(this.badgeTitle).match(/.+assistant/i);
    return addSuffix ? `${this.badgeTitle} Assistant` : this.badgeTitle;
  }
}
